import { TimeSlot } from "../../AppDataProvider/types";

export const getClosestTimeSlots = (
  selectedDateTime: Date,
  timeSlots: TimeSlot[],
  maxTimeSlotCount: number,
): TimeSlot[] => {
  // return an empty array if there are no timeslots
  if (timeSlots.length === 0) {
    return [];
  }
  // return the closest time slots to the searched date and time, up to the maxTimeSlotCount
  const selectedTime = selectedDateTime.getTime();

  const closestTimeSlots = timeSlots
    .map((timeSlot) => ({
      difference: Math.abs(
        new Date(timeSlot.interval.start).getTime() - selectedTime,
      ),
      timeSlot,
    }))
    .sort((a, b) => a.difference - b.difference)
    .slice(0, maxTimeSlotCount)
    .map((item) => item.timeSlot);

  return closestTimeSlots.sort(
    (a, b) =>
      new Date(a.interval.start).getTime() -
      new Date(b.interval.start).getTime(),
  );
};
